import { render, staticRenderFns } from "./UnmatchedCharacterCard.vue?vue&type=template&id=5e47e0e6&scoped=true&"
import script from "./UnmatchedCharacterCard.vue?vue&type=script&lang=js&"
export * from "./UnmatchedCharacterCard.vue?vue&type=script&lang=js&"
import style0 from "./UnmatchedCharacterCard.vue?vue&type=style&index=0&id=5e47e0e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e47e0e6",
  null
  
)

export default component.exports